import { render, staticRenderFns } from "./GlobalLoader.vue?vue&type=template&id=4a3e0127&"
import script from "./GlobalLoader.vue?vue&type=script&lang=js&"
export * from "./GlobalLoader.vue?vue&type=script&lang=js&"
import style0 from "./GlobalLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports